// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageHeader_pageHeader__2kXG-","logo":"PageHeader_logo__1dB_3","account":"PageHeader_account__2plL8"};